import { useEffect, useState } from "react";
import { fetchSiteSettings } from "../services/publicApi";

export function useSiteSettings() {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    let isMounted = true;

    async function loadSettings() {
      try {
        const data = await fetchSiteSettings();

        if (isMounted) {
          setSettings(data);
          setError("");
        }
      } catch (requestError) {
        if (isMounted) {
          setError("We could not load this page right now.");
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    }

    loadSettings();

    return () => {
      isMounted = false;
    };
  }, []);

  return { settings, loading, error };
}